import { Form as _Form, FormProps as _FormProps } from "reactstrap";

export const Form = _Form;
export type FormProps = _FormProps;
